// extracted by mini-css-extract-plugin
export default {"userBadge":"NfApCq495osrOwlnnSfL","icon":"wQJlqHOhUuKib2ZfDEax","active":"pObnEpfOfGWv5ZFxlOWU"};